import { api } from "../App";
import { createNotification } from "../components/Notifications/Notifications";
import { SET_ACTIVITY_LIST, SET_ACTIVITY_LOADING } from "./types";



export const getActivity = () => async (dispatch) => {
  try {
    dispatch({ type: SET_ACTIVITY_LOADING, payload: true });
    const { data } = await api.get('/activity')
    dispatch({ type: SET_ACTIVITY_LIST, payload: data })
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_ACTIVITY_LOADING, payload: false });
  }
}

export const createActivity = (data) => async (dispatch, getState) => {
  let success
  try {
    dispatch({ type: SET_ACTIVITY_LOADING, payload: true });
    await api.post('/activity', data);
    await dispatch(getActivity())
    success = true
  } catch (ERR) {
    createNotification('error', ERR.response.data.message)
  } finally {
    dispatch({ type: SET_ACTIVITY_LOADING, payload: false });
    return success
  }
}

export const updateActivity = (id, data) => async (dispatch, getState) => {
  let success
  try {
    dispatch({ type: SET_ACTIVITY_LOADING, payload: true });
    await api.put(`/activity/${id}`, data);
    await dispatch(getActivity())
    success = true
  } catch (ERR) {
    createNotification('error', ERR.response.data.message)
  } finally {
    dispatch({ type: SET_ACTIVITY_LOADING, payload: false });
    return success
  }
}

export const deleteActivity = (id) => async (dispatch, getState) => {
  let success
  try {
    dispatch({ type: SET_ACTIVITY_LOADING, payload: true });
    await api.delete(`/activity/${id}`);
    await dispatch(getActivity())
    success = true
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_ACTIVITY_LOADING, payload: false });
    return success
  }
}